<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.product_name" placeholder="请输入课程名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="typeName" label="分类名称"></el-table-column>
            <el-table-column prop="productName" label="课程名称"></el-table-column>
            <el-table-column prop="productSort" label="序号"></el-table-column>
            <el-table-column prop="videoCount" label="视频数量"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <span>{{ scope.row.productStatus == 1 ? "上架" : "下架" }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="productPrize" label="价格"></el-table-column>
            <el-table-column prop="productImage" label="图片">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="img" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.productImages)" :initial-index="index"
                        v-for="(img, index) in getThumbImageSrcList(scope.row.productImages)"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.productDate) }}
                </template>
            </el-table-column>
            <el-table-column label="查看课程码" width="150">
                <template slot-scope="scope">
                    <el-button @click="qrCodeShowOpen(scope.row.productId)" type="text" size="small">查看课程码</el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="80%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="课程分类">
                        <el-select v-model="handleInfo.typeId" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in types" :key="item.typeId" :label="item.typeName" :value="item.typeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课程名称">
                        <el-input v-model="handleInfo.productName"></el-input>
                    </el-form-item>
                    <el-form-item label="课程状态">
                        <el-select v-model="handleInfo.productStatus" style="width: 100%;">
                            <el-option label="上架" :value="1"></el-option>
                            <el-option label="下架" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课程序号">
                        <el-input v-model="handleInfo.productSort"></el-input>
                    </el-form-item>
                    <el-form-item label="课程价格">
                        <el-input v-model="handleInfo.productPrize"></el-input>
                    </el-form-item>
                    <el-form-item label="课程图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('productImages')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('productImages', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'productImages' }" accept=".jpg,.jpeg,.bmp,.png"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="课程简述">
                        <el-input type="textarea" v-model="handleInfo.productDesc" :rows="3"></el-input>
                    </el-form-item>
                    <el-form-item label="课程内容">
                        <quill-editor v-model="handleInfo.productContent" style="width: 100%; height: 600px; margin-bottom: 10px;"></quill-editor>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="课程二维码" :visible.sync="isQRCodeShow" width="800px" :close-on-click-modal="false">
            <el-image style="width: 100%; height: 640px;" :src="qrCodeUrl" fit="contain"></el-image>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"


import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            types: [],
            isQRCodeShow: false,
            qrCodeUrl: ""
        }
    },
    methods: {
        handleCurrentChange: function (val) {
            this.currentRow = val;
            this.$emit("current-change", val.productId);
        },
        qrCodeShowOpen: function(productId) {
            const QRCode = require('qrcode');
            QRCode.toDataURL(process.env.VUE_APP_URL + "/pages/shop/product?id=" + productId, { width: 1000, height: 1000 }, function (err, url) {
                if (err) {
                    console.log(err);
                } else {
                    this.qrCodeUrl = url;
                }
            }.bind(this));
            this.isQRCodeShow = true;
        },
        qrCodeShowClose: function() {
            this.isQRCodeShow = false;
        }
    },
    created: async function () {
        this.tag = "PRODUCT";
        this.uploads.push({
            column: "productImages",
            files: []
        });
        this.types = await doGet(API.ALL.TYPE);
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>